import { connect } from 'react-redux';
import { fetchCaseStudies } from 'marketing/ducks';
import { excludeDeprecated, getSubCategories } from 'common/ducks/categories';
import CaseStudies from 'marketing/components/case_studies';

const mapStateToProps = ({ marketing, categories }) => {
  return {
    items: marketing.caseStudies,
    subCategories: getSubCategories({ data: excludeDeprecated(categories.data) })
  };
}

export default connect(mapStateToProps, { fetchCaseStudies })(CaseStudies);



// WEBPACK FOOTER //
// ./marketing/containers/case_studies.js